import { ApplicationResourcesService } from '../application-resources.service';
import {
  ApplicationResource,
  ApplicationResourceType,
} from 'src/app/services/application-resources/models/application-resource';
import { BaseResourceData } from '../models/base/base-resource-data';
import { Injectable } from '@angular/core';

@Injectable()
export abstract class BaseResourceService<T extends BaseResourceData> {
  constructor(
    private applicationResourceService: ApplicationResourcesService
  ) {}

  abstract type: ApplicationResourceType; // todo use static string keys instead of magic strings

  public getResources(): ApplicationResource<T>[] {
    const applicationResources = this.applicationResourceService
      .applicationResources;

    return applicationResources.filter(
      (resource) => resource.type === this.type
    );
  }

  public getResource(id: string): ApplicationResource<T> {
    return this.applicationResourceService.applicationResources.find(
      (r) => r.id === id
    );
  }

  public addResource(resource: ApplicationResource<T>) {
    return this.applicationResourceService.add(resource);
  }

  public editResource(resource: ApplicationResource<T>) {
    return this.applicationResourceService.edit(resource);
  }

  public deleteResource(resourceId: string) {
    return this.applicationResourceService.delete(resourceId);
  }
}
